import React from "react";

const ImagenContainerCiclos = () => {
  return (
    <div className="py-2 my-4">
      <img
        src="assets/imagenes/web_mc_infografia_tips_ciclos_con_motorizados_1.png"
        class="img1 img-fluid"
      ></img>
      <img
        src="assets/imagenes/web_mc_infografia_tips_ciclos_con_motorizados_1_celular.png"
        class="img2 img-fluid"
      ></img>
    </div>
  );
};

export default ImagenContainerCiclos;
